(() => {
  const editorUrl = "/?tool=hapines-pattern";
  const staleEditorSelectors = [
    'a[href*="tool-hapines-pattern-index.html"]',
    'a[href="/pages/tool-hapines-pattern"]',
    'a[href="/pages/tools?tool=hapines-pattern"]'
  ].join(",");

  const assets = {
    cssUrl: "//www.twisted-electrons.com/cdn/shop/t/11/assets/tool-hapines-pattern-styles.css?v=147905568569126862311782115106",
    appUrl: "//www.twisted-electrons.com/cdn/shop/t/11/assets/tool-hapines-pattern-app.js?v=166849520619541965481782115106",
    logoUrl: "//www.twisted-electrons.com/cdn/shop/t/11/assets/tool-hapines-pattern-logo.png?v=139577949800055402531782115106",
    voiceIcons: [
      "//www.twisted-electrons.com/cdn/shop/t/11/assets/tool-hapines-pattern-triangle.png?v=22681163899356422331782115106",
      "//www.twisted-electrons.com/cdn/shop/t/11/assets/tool-hapines-pattern-square1.png?v=17526056200839551591782115106",
      "//www.twisted-electrons.com/cdn/shop/t/11/assets/tool-hapines-pattern-square2.png?v=180842000558338583241782115106",
      "//www.twisted-electrons.com/cdn/shop/t/11/assets/tool-hapines-pattern-drums.png?v=73649428875311555661782115106"
    ]
  };

  function repairHapinesPatternLinks() {
    document.querySelectorAll(staleEditorSelectors).forEach((link) => {
      link.setAttribute("href", editorUrl);
    });
  }

  function mountHapinesPatternEditorRoute() {
    if (new URLSearchParams(window.location.search).get("tool") !== "hapines-pattern") return;
    if (document.querySelector("[data-hapines-pattern-editor]")) return;

    document.title = "hapiNES L Pattern Editor - Twisted Electrons";
    document.documentElement.classList.add("is-hapines-pattern-route");

    const route = document.createElement("main");
    route.setAttribute("data-hapines-pattern-fallback-route", "");
    route.innerHTML = `
      <div class="hapines-pattern-editor" data-hapines-pattern-editor>
        <header class="app-header">
          <div class="title-block">
            <img class="brand-logo" src="${assets.logoUrl}" alt="hapiNES L" width="187" height="50">
          </div>
          <div class="status" id="status-indicator" role="button" tabindex="0">Disconnected</div>
        </header>

        <section class="panel pattern-panel">
          <div class="panel-header">
            <h2>Patterns</h2>
          </div>
          <div class="pattern-strip" id="pattern-strip"></div>
        </section>

        <section class="panel settings-panel">
          <div class="panel-header">
            <h2>Settings</h2>
          </div>
          <div class="settings-tabs" id="settings-tabs" role="tablist" aria-label="Settings">
            <button type="button" class="settings-tab" data-settings-tab="clock" role="tab">Clock</button>
            <button type="button" class="settings-tab" data-settings-tab="midi" role="tab">MIDI</button>
          </div>
          <div class="settings-page" id="clock-settings-page" data-settings-page="clock" role="tabpanel">
            <div class="setting-controls" id="setting-controls"></div>
          </div>
          <div class="settings-page" id="midi-settings-page" data-settings-page="midi" role="tabpanel" hidden>
            <div class="midi-channel-controls" id="midi-channel-controls"></div>
          </div>
        </section>

        <section class="visualizer">
          <section class="panel sequence-panel">
            <div class="panel-header">
              <h2>Sequence</h2>
            </div>
            <div class="voice-tabs" id="voice-tabs"></div>
            <div class="track-grid" id="track-grid"></div>
          </section>
        </section>
      </div>
    `;

    Array.from(document.body.children).forEach((child) => {
      if (child.tagName === "SCRIPT" || child.tagName === "STYLE" || child.tagName === "LINK") return;
      child.hidden = true;
    });
    document.body.appendChild(route);

    window.HAPINES_PATTERN_ASSETS = { voiceIcons: assets.voiceIcons };

    if (!document.querySelector("link[data-hapines-pattern-css]")) {
      const stylesheet = document.createElement("link");
      stylesheet.rel = "stylesheet";
      stylesheet.href = assets.cssUrl;
      stylesheet.dataset.hapinesPatternCss = "true";
      document.head.appendChild(stylesheet);
    }

    if (!document.querySelector("script[data-hapines-pattern-app]")) {
      const script = document.createElement("script");
      script.type = "module";
      script.src = assets.appUrl;
      script.dataset.hapinesPatternApp = "true";
      document.body.appendChild(script);
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => {
      repairHapinesPatternLinks();
      mountHapinesPatternEditorRoute();
    });
  } else {
    repairHapinesPatternLinks();
    mountHapinesPatternEditorRoute();
  }

  window.setTimeout(repairHapinesPatternLinks, 250);
  window.setTimeout(repairHapinesPatternLinks, 1000);
})();

const products = [
  {
    id: "flexfm",
    name: "FLEXFM",
    category: "drums fm",
    type: "Hybrid groovebox · Preorder",
    price: "999 EUR",
    image: "//www.twisted-electrons.com/cdn/shop/t/11/assets/flexfm-home-threequarter.png?v=23549138055874696511791903757",
    imageSrcset: "//www.twisted-electrons.com/cdn/shop/t/11/assets/flexfm-home-threequarter_640x.png?v=23549138055874696511791903757 640w, //www.twisted-electrons.com/cdn/shop/t/11/assets/flexfm-home-threequarter_1200x.png?v=23549138055874696511791903757 1200w, //www.twisted-electrons.com/cdn/shop/t/11/assets/flexfm-home-threequarter_1536x.png?v=23549138055874696511791903757 1536w",
    alt: "FLEXFM hybrid groovebox, three-quarter view",
    shop: "/products/flexfm",
    cta: "Preorder FLEXFM",
    tagline: "Eight tracks of synthesis and sampling, real analogue filters, and three ways to morph. Follow the idea.",
    stats: [["Engine", "Synth + sampler"], ["Tracks", "8"], ["Filters", "8 analog"]],
    specs: ["4 operators per track", "FM / AM / RM", "Three morphs", "USB audio"]
  },
  {
    id: "twistfm",
    name: "TWISTfm",
    category: "fm",
    type: "FM polysynth",
    price: "979 EUR",
    image: "//www.twisted-electrons.com/cdn/shop/t/11/assets/twistfm-main.jpg?v=79282825062507020261782115107",
    imageSrcset: "//www.twisted-electrons.com/cdn/shop/t/11/assets/twistfm-main_420x.jpg?v=79282825062507020261782115107 420w, //www.twisted-electrons.com/cdn/shop/t/11/assets/twistfm-main_640x.jpg?v=79282825062507020261782115107 640w, //www.twisted-electrons.com/cdn/shop/t/11/assets/twistfm-main_900x.jpg?v=79282825062507020261782115107 900w, //www.twisted-electrons.com/cdn/shop/t/11/assets/twistfm-main_1200x.jpg?v=79282825062507020261782115107 1200w, //www.twisted-electrons.com/cdn/shop/t/11/assets/twistfm-main_1600x.jpg?v=79282825062507020261782115107 1600w",
    alt: "TWISTfm synthesizer front panel",
    shop: "/products/twistfm",
    tagline: "Eight-voice OPL3 FM with analog multimode filters, firmware 3.3 looping envelopes, MPE, ribbon control, and a browser editor for deep setup.",
    stats: [
      ["Engine", "Dual OPL3"],
      ["Voices", "8"],
      ["Filters", "8 analog"]
    ],
    specs: ["Dual YMF262", "Firmware 3.3", "Looping envelopes", "Web editor"]
  },
  {
    id: "blastbeats",
    name: "BlastBeats",
    category: "drums fm",
    type: "FM groovebox",
    price: "490 EUR",
    image: "//www.twisted-electrons.com/cdn/shop/t/11/assets/blastbeats-main.jpg?v=138749660512857813501782115106",
    imageSrcset: "//www.twisted-electrons.com/cdn/shop/t/11/assets/blastbeats-main_420x.jpg?v=138749660512857813501782115106 420w, //www.twisted-electrons.com/cdn/shop/t/11/assets/blastbeats-main_640x.jpg?v=138749660512857813501782115106 640w, //www.twisted-electrons.com/cdn/shop/t/11/assets/blastbeats-main_900x.jpg?v=138749660512857813501782115106 900w, //www.twisted-electrons.com/cdn/shop/t/11/assets/blastbeats-main_1200x.jpg?v=138749660512857813501782115106 1200w, //www.twisted-electrons.com/cdn/shop/t/11/assets/blastbeats-main_1600x.jpg?v=138749660512857813501782115106 1600w",
    alt: "BlastBeats groovebox front panel",
    shop: "/products/blastbeats",
    tagline: "A 10-voice OPL3 groovebox with six drum voices, four synth instruments, fader automation, tricks, and SD-card kits.",
    stats: [
      ["Engine", "OPL3"],
      ["Voices", "10"],
      ["Faders", "56"]
    ],
    specs: ["6 drums", "4 synths", "64 steps", "Quad outputs"]
  },
  {
    id: "megafm",
    name: "MEGAfm II",
    category: "fm",
    type: "Vintage FM synth",
    price: "456 EUR",
    image: "//www.twisted-electrons.com/cdn/shop/t/11/assets/megafm-main.jpg?v=29746167913360983041782115106",
    imageSrcset: "//www.twisted-electrons.com/cdn/shop/t/11/assets/megafm-main_420x.jpg?v=29746167913360983041782115106 420w, //www.twisted-electrons.com/cdn/shop/t/11/assets/megafm-main_640x.jpg?v=29746167913360983041782115106 640w, //www.twisted-electrons.com/cdn/shop/t/11/assets/megafm-main_900x.jpg?v=29746167913360983041782115106 900w, //www.twisted-electrons.com/cdn/shop/t/11/assets/megafm-main_1200x.jpg?v=29746167913360983041782115106 1200w, //www.twisted-electrons.com/cdn/shop/t/11/assets/megafm-main_1600x.jpg?v=29746167913360983041782115106 1600w",
    alt: "MEGAfm II synthesizer",
    shop: "/products/megafm",
    tagline: "Dual vintage FM chips, 12 voices, 32 operator faders, firmware 5.0 bidirectional SYSEX, and editor support for deep control.",
    stats: [
      ["Engine", "Dual YM"],
      ["Voices", "12"],
      ["Faders", "32"]
    ],
    specs: ["Firmware 5.0", "Bidirectional SYSEX", "12 voices", "Editor support"]
  },
  {
    id: "therapsid",
    name: "TherapSID",
    category: "chip",
    type: "SID synthesizer",
    price: "474 EUR",
    image: "//www.twisted-electrons.com/cdn/shop/t/11/assets/therapsid-main.jpg?v=183066808004639322281782115106",
    imageSrcset: "//www.twisted-electrons.com/cdn/shop/t/11/assets/therapsid-main_420x.jpg?v=183066808004639322281782115106 420w, //www.twisted-electrons.com/cdn/shop/t/11/assets/therapsid-main_640x.jpg?v=183066808004639322281782115106 640w, //www.twisted-electrons.com/cdn/shop/t/11/assets/therapsid-main_900x.jpg?v=183066808004639322281782115106 900w, //www.twisted-electrons.com/cdn/shop/t/11/assets/therapsid-main_1200x.jpg?v=183066808004639322281782115106 1200w, //www.twisted-electrons.com/cdn/shop/t/11/assets/therapsid-main_1600x.jpg?v=183066808004639322281782115106 1600w",
    alt: "TherapSID synthesizer",
    shop: "/products/therapsid-mk3",
    tagline: "A SID-focused synth with MKIII hardware updates, CV/Gate, analog filtering, arpeggiation, presets, and deep knob control.",
    stats: [
      ["Engine", "Dual SID"],
      ["Controls", "68"],
      ["CV", "3 inputs"]
    ],
    specs: ["1 or 2 SID chips", "CV/Gate", "Analog filter", "100 presets"]
  },
  {
    id: "ay3",
    name: "AY3 MKII",
    category: "chip",
    type: "8-bit polysynth",
    price: "255 EUR",
    image: "//www.twisted-electrons.com/cdn/shop/t/11/assets/ay3-main.jpg?v=93460505360136720671782115106",
    imageSrcset: "//www.twisted-electrons.com/cdn/shop/t/11/assets/ay3-main_420x.jpg?v=93460505360136720671782115106 420w, //www.twisted-electrons.com/cdn/shop/t/11/assets/ay3-main_640x.jpg?v=93460505360136720671782115106 640w, //www.twisted-electrons.com/cdn/shop/t/11/assets/ay3-main_900x.jpg?v=93460505360136720671782115106 900w, //www.twisted-electrons.com/cdn/shop/t/11/assets/ay3-main_1200x.jpg?v=93460505360136720671782115106 1200w, //www.twisted-electrons.com/cdn/shop/t/11/assets/ay3-main_1600x.jpg?v=93460505360136720671782115106 1600w",
    alt: "AY3 MKII synthesizer",
    shop: "/products/ay3-mkii",
    tagline: "Dual AY-3 chips deliver six-voice stereo polyphony with sequencer, arpeggiators, modulation, memory, and Phoenix V4 firmware.",
    stats: [
      ["Engine", "Dual AY-3"],
      ["Voices", "6"],
      ["Memory", "64"]
    ],
    specs: ["6 voices", "16-step sequencer", "64 presets", "MIDI CC"]
  },
  {
    id: "hapines",
    name: "hapiNES L",
    category: "chip",
    type: "NES-style synth",
    price: "295 EUR",
    image: "//www.twisted-electrons.com/cdn/shop/t/11/assets/hapines-main.jpg?v=103434000873493350631782115106",
    imageSrcset: "//www.twisted-electrons.com/cdn/shop/t/11/assets/hapines-main_420x.jpg?v=103434000873493350631782115106 420w, //www.twisted-electrons.com/cdn/shop/t/11/assets/hapines-main_640x.jpg?v=103434000873493350631782115106 640w, //www.twisted-electrons.com/cdn/shop/t/11/assets/hapines-main_900x.jpg?v=103434000873493350631782115106 900w, //www.twisted-electrons.com/cdn/shop/t/11/assets/hapines-main_1200x.jpg?v=103434000873493350631782115106 1200w, //www.twisted-electrons.com/cdn/shop/t/11/assets/hapines-main_1600x.jpg?v=103434000873493350631782115106 1600w",
    alt: "hapiNES L synthesizer",
    shop: "/products/hapines-l",
    tagline: "A four-track chiptune synth inspired by the NES sound chip, with MIDI, sync I/O, metal hardware, and live pattern tools.",
    stats: [
      ["Engine", "NES-style"],
      ["Tracks", "4"],
      ["Patterns", "16"]
    ],
    specs: ["4 tracks", "59 drum sounds", "16 arp modes", "Sync I/O"]
  },
  {
    id: "deton8",
    name: "deton8",
    category: "drums",
    type: "Sample drum machine",
    price: "246 EUR",
    image: "//www.twisted-electrons.com/cdn/shop/t/11/assets/deton8-main.jpg?v=42352369966492021241782115107",
    imageSrcset: "//www.twisted-electrons.com/cdn/shop/t/11/assets/deton8-main_420x.jpg?v=42352369966492021241782115107 420w, //www.twisted-electrons.com/cdn/shop/t/11/assets/deton8-main_640x.jpg?v=42352369966492021241782115107 640w, //www.twisted-electrons.com/cdn/shop/t/11/assets/deton8-main_900x.jpg?v=42352369966492021241782115107 900w, //www.twisted-electrons.com/cdn/shop/t/11/assets/deton8-main_1200x.jpg?v=42352369966492021241782115107 1200w, //www.twisted-electrons.com/cdn/shop/t/11/assets/deton8-main_1600x.jpg?v=42352369966492021241782115107 1600w",
    alt: "deton8 drum machine",
    shop: "/products/deton8",
    tagline: "Crunchy 8-bit samples, wavetable synthesis, hands-on stutter modes, modulation, delay, ring mod, swing, and sample kits.",
    stats: [
      ["Engine", "8-bit"],
      ["Voices", "8"],
      ["Patterns", "16"]
    ],
    specs: ["8 voices", "Stutter FX", "Sample kits", "USB-MIDI"]
  },
  {
    id: "acid8",
    name: "acid8 MKII",
    category: "acid",
    type: "Hybrid acid machine",
    price: "312 EUR",
    image: "//www.twisted-electrons.com/cdn/shop/t/11/assets/acid8-main.jpg?v=61588537280498950251782115106",
    imageSrcset: "//www.twisted-electrons.com/cdn/shop/t/11/assets/acid8-main_420x.jpg?v=61588537280498950251782115106 420w, //www.twisted-electrons.com/cdn/shop/t/11/assets/acid8-main_640x.jpg?v=61588537280498950251782115106 640w, //www.twisted-electrons.com/cdn/shop/t/11/assets/acid8-main_900x.jpg?v=61588537280498950251782115106 900w, //www.twisted-electrons.com/cdn/shop/t/11/assets/acid8-main_1200x.jpg?v=61588537280498950251782115106 1200w, //www.twisted-electrons.com/cdn/shop/t/11/assets/acid8-main_1600x.jpg?v=61588537280498950251782115106 1600w",
    alt: "acid8 MKII synthesizer",
    shop: "/products/acid8-mkii",
    tagline: "An 8-bit oscillator, analog VCA and resonant low-pass filter, 16 waveforms, DSP tricks, and an acid-minded step sequencer.",
    stats: [
      ["Engine", "8-bit"],
      ["Patterns", "128"],
      ["Waves", "16"]
    ],
    specs: ["Analog filter", "16 waves", "128 patterns", "MIDI sync"]
  }
];

const supportResources = [
  {
    id: "twistfm",
    name: "TWISTfm",
    image: "https://static.wixstatic.com/media/b8c32b_424933facdda40cbbbe3cae27710e982~mv2.jpg/v1/crop/x_0,y_11,w_1802,h_1802/fill/w_121,h_121,al_c,q_80,usm_0.66_1.00_0.01,enc_avif,quality_auto/Loupe%20TWIST_edited.jpg",
    alt: "TWISTfm support thumbnail",
    links: [
      { label: "Manual", href: "/pages/manual-twistfm", tone: "manual" },
      { label: "Firmware 3.3", href: "//www.twisted-electrons.com/cdn/shop/t/11/assets/firmware-twistfm.zip?v=1492677440985416941793103461", tone: "firmware" },
      { label: "Factory Presets 1.1", href: "//www.twisted-electrons.com/cdn/shop/t/11/assets/twistfm-factory-presets.zip?v=157368145937310990551782115105", tone: "utility" },
      { label: "Editor", href: "/pages/tool-twistfm?view=tool-twistfm", tone: "tool" }
    ]
  },
  {
    id: "blastbeats",
    name: "BlastBeats",
    image: "https://static.wixstatic.com/media/b8c32b_f5e7f522fcac4e77b005b763a341d9fd~mv2.png/v1/crop/x_37,y_20,w_119,h_119/fill/w_121,h_121,al_c,lg_1,q_85,enc_avif,quality_auto/blastBeat.png",
    alt: "BlastBeats support thumbnail",
    links: [
      { label: "Manual", href: "/pages/manual-blastbeats", tone: "manual" },
      { label: "Firmware 7.1", href: "https://cdn.shopify.com/s/files/1/0945/9181/1969/files/BlastBeats7.1.zip?v=1788930292", tone: "firmware" },
      { label: "Factory Card 2025-12-10", href: "//www.twisted-electrons.com/cdn/shop/t/11/assets/blastbeats-factory-card.zip?v=4718737870148033441782115108", tone: "utility" },
      { label: "Editor", href: "//www.twisted-electrons.com/cdn/shop/t/11/assets/tool-blastbeats-index.html?v=133406703865838792791782115106", tone: "tool" }
    ]
  },
  {
    id: "megafm",
    name: "MEGAfm II",
    image: "https://static.wixstatic.com/media/b8c32b_eaf514b3d18b485f80f7b5b52f7d25e6~mv2.jpeg/v1/crop/x_116,y_128,w_558,h_554/fill/w_121,h_121,al_c,q_80,usm_0.66_1.00_0.01,enc_avif,quality_auto/MEGA-FM-SORTIES-1024x682.jpeg",
    alt: "MEGAfm II support thumbnail",
    links: [
      { label: "Manual", href: "//www.twisted-electrons.com/cdn/shop/t/11/assets/manual-megafm.pdf?v=93008594083086147621782115108", tone: "manual" },
      { label: "Firmware 5.3", href: "//www.twisted-electrons.com/cdn/shop/files/MEGAfm.5.3.zip?v=14179418215136277879", tone: "firmware" },
      { label: "OSX", href: "//www.twisted-electrons.com/cdn/shop/t/11/assets/MEGAfm_Control_macOS_universal_v0.1.0.pkg?v=38466128708810554971782115109", tone: "controller" },
      { label: "WIN", href: "//www.twisted-electrons.com/cdn/shop/t/11/assets/MEGAfm_Control_Windows_x64_v0.1.0.zip?v=137702827261068054931782115108", tone: "controller" },
      { label: "MAX4LIVE", href: "https://drmika.gumroad.com/l/megafm", tone: "utility" },
      { label: "settings tool", href: "//www.twisted-electrons.com/cdn/shop/t/11/assets/tool-megafm-editor.html?v=46735983435303560191782115107", tone: "tool" },
      { label: "Sysex updater", href: "//www.twisted-electrons.com/cdn/shop/t/11/assets/tool-twissex-index.html?v=152206471787618261441782115106", tone: "firmware" }
    ]
  },
  {
    id: "therapsid",
    name: "TherapSID",
    image: "https://static.wixstatic.com/media/b8c32b_202f82bb7b2d443bbf4212a59fa8cb95~mv2.png/v1/crop/x_49,y_0,w_91,h_92/fill/w_121,h_121,al_c,lg_1,q_85,enc_avif,quality_auto/TSID%20tool.png",
    alt: "TherapSID support thumbnail",
    links: [
      { label: "Manual", href: "//www.twisted-electrons.com/cdn/shop/t/11/assets/manual-therapsid-mk3.pdf?v=47346392967118431041782115109", tone: "manual" },
      { label: "Firmware 3.1", href: "//www.twisted-electrons.com/cdn/shop/t/11/assets/firmware-therapsid-mk3.zip?v=99177014278965422501782115107", tone: "firmware" },
      { label: "Factory Presets", href: "//www.twisted-electrons.com/cdn/shop/t/11/assets/therapsid-factory-presets.zip?v=85679294810316884381782115106", tone: "utility" },
      { label: "Editor", href: "//www.twisted-electrons.com/cdn/shop/t/11/assets/tool-therapsid-index.html?v=175456545637723690961782115106", tone: "tool" },
      { label: "Sysex updater", href: "//www.twisted-electrons.com/cdn/shop/t/11/assets/tool-twissex-index.html?v=152206471787618261441782115106", tone: "firmware" }
    ]
  },
  {
    id: "ay3",
    name: "AY3 MKII",
    image: "https://static.wixstatic.com/media/b8c32b_3ae5c456c0404cf6802aa7ab9bbe1163~mv2.jpeg/v1/crop/x_208,y_106,w_589,h_591/fill/w_121,h_121,al_c,q_80,usm_0.66_1.00_0.01,enc_avif,quality_auto/AY3-gauche.jpeg",
    alt: "AY3 MKII support thumbnail",
    links: [
      { label: "Manual", href: "//www.twisted-electrons.com/cdn/shop/t/11/assets/manual-ay3.pdf?v=26182513438490866851782115108", tone: "manual" },
      { label: "Firmware 4.4", href: "//www.twisted-electrons.com/cdn/shop/t/11/assets/firmware-ay3-mkii.zip?v=173735513320390389591782115107", tone: "firmware" },
      { label: "AYMID Player + Tracker", href: "//www.twisted-electrons.com/cdn/shop/t/11/assets/aymid-player-tracker.zip?v=50432244355671834301782115109", tone: "utility" },
      { label: "Editor", href: "//www.twisted-electrons.com/cdn/shop/t/11/assets/tool-ay3-index.html?v=170375018075060171651782115106", tone: "tool" },
      { label: "Sysex updater", href: "//www.twisted-electrons.com/cdn/shop/t/11/assets/tool-twissex-index.html?v=152206471787618261441782115106", tone: "firmware" }
    ]
  },
  {
    id: "hapines",
    name: "hapiNES L",
    image: "https://static.wixstatic.com/media/b8c32b_6df9efe31b294a8a9a4afd7ea44ba82c~mv2.jpg/v1/crop/x_373,y_0,w_526,h_526/fill/w_121,h_121,al_c,q_80,usm_0.66_1.00_0.01,enc_avif,quality_auto/h_jpf.jpg",
    alt: "hapiNES L support thumbnail",
    links: [
      { label: "Manual", href: "//www.twisted-electrons.com/cdn/shop/t/11/assets/manual-hapines-l.pdf?v=182053764937184813321782115108", tone: "manual" },
      { label: "Firmware 10", href: "//www.twisted-electrons.com/cdn/shop/t/11/assets/firmware-hapines-l.zip?v=27063722245287061181782115106", tone: "firmware" },
      { label: "Update", href: "https://www.twisted-electrons.com/?tool=update&device=hapines-l", tone: "firmware" },
      { label: "Editor", href: "/?tool=hapines-pattern", tone: "tool" }
    ]
  },
  {
    id: "deton8",
    name: "deton8",
    image: "https://static.wixstatic.com/media/b8c32b_3c99a7185b714af1a1fb1368069d7b36~mv2.jpg/v1/crop/x_409,y_288,w_1191,h_1191/fill/w_121,h_121,al_c,q_80,usm_0.66_1.00_0.01,enc_avif,quality_auto/deton8.jpg",
    alt: "deton8 support thumbnail",
    links: [
      { label: "Manual", href: "//www.twisted-electrons.com/cdn/shop/t/11/assets/manual-deton8-index.html?v=28775929167036962741782115106", tone: "manual" },
      { label: "Firmware 11", href: "//www.twisted-electrons.com/cdn/shop/t/11/assets/firmware-deton8.zip?v=136011774322139913901787572136", tone: "firmware" },
      { label: "Update", href: "https://www.twisted-electrons.com/?tool=update&device=deton8", tone: "firmware" },
      { label: "Editor", href: "/pages/tool-deton8", tone: "tool" }
    ]
  },
  {
    id: "acid8",
    name: "acid8 MKII",
    image: "https://static.wixstatic.com/media/b8c32b_4932f339f0b249de90d623c5deec94ac~mv2.jpeg/v1/crop/x_175,y_51,w_307,h_306/fill/w_121,h_121,al_c,q_80,usm_0.66_1.00_0.01,enc_avif,quality_auto/acid8-e1506772504495.jpeg",
    alt: "acid8 MKII support thumbnail",
    links: [
      { label: "Manual", href: "//www.twisted-electrons.com/cdn/shop/t/11/assets/manual-acid8.pdf?v=120082225755508365121782115107", tone: "manual" },
      { label: "Firmware 3.0", href: "//www.twisted-electrons.com/cdn/shop/t/11/assets/firmware-acid8-mkii.zip?v=55225565402756961511782115107", tone: "firmware" },
      { label: "Editor", href: "//www.twisted-electrons.com/cdn/shop/t/11/assets/tool-acid8-index.html?v=52085220248212971551782115106", tone: "tool" },
      { label: "Sysex updater", href: "//www.twisted-electrons.com/cdn/shop/t/11/assets/tool-twissex-index.html?v=152206471787618261441782115106", tone: "firmware" }
    ]
  }
];

const productGrid = document.querySelector("[data-product-grid]");
const heroSection = document.querySelector(".hero");
const heroImage = document.querySelector("[data-hero-image]");
const heroTitle = document.querySelector("[data-hero-title]");
const heroCopy = document.querySelector("[data-hero-copy]");
const heroShop = document.querySelector("[data-hero-shop]");
const heroStats = document.querySelector("[data-hero-stats]");
const heroButtons = Array.from(document.querySelectorAll("[data-hero-key]"));
const heroRotationIds = heroButtons.map((button) => button.dataset.heroKey).filter(Boolean);
const supportGrid = document.querySelector("[data-support-grid]");
const chipFleet = document.querySelector("[data-chip-fleet]");
const HERO_ROTATE_MS = 10000;
const HERO_FADE_MS = 260;
const initialHeroButton = heroButtons.find((button) => button.classList.contains("is-active"));
let activeHeroId = initialHeroButton ? initialHeroButton.dataset.heroKey : "";

if (!activeHeroId && products[0]) {
  activeHeroId = products[0].id;
}

let heroRotationTimer = null;
let heroTransitionTimer = null;
let heroRotationManuallyStopped = !!heroSection?.hasAttribute("data-hero-pinned");

function chipParticle(index) {
  const streak = index % 5 === 0;
  const className = streak ? "chip-fleet__particle chip-fleet__particle--streak" : "chip-fleet__particle";
  const size = streak ? 2 + Math.random() * 1.4 : 1.4 + Math.random() * 2.8;
  const left = Math.random() * 100;
  const top = Math.random() * 100;
  const duration = 7 + Math.random() * 8;
  const delay = -Math.random() * duration;
  const drift = -48 + Math.random() * 96;
  const opacity = 0.22 + Math.random() * 0.66;
  const stretch = 30 + Math.random() * 48;

  return `
    <span
      class="${className}"
      style="--left:${left.toFixed(2)}%; --top:${top.toFixed(2)}%; --size:${size.toFixed(2)}px; --duration:${duration.toFixed(2)}s; --delay:${delay.toFixed(2)}s; --drift:${drift.toFixed(2)}px; --opacity:${opacity.toFixed(2)}; --stretch:${stretch.toFixed(2)}px;"
    ></span>
  `;
}

function chipSprite(scale, index) {
  const topPattern = [8, 18, 28, 40, 52, 66, 78, 22, 60, 34];
  const driftPattern = [18, -14, 26, -20, 12, -24, 20, 30, -16, 10];
  const tiltPattern = [-22, 16, -14, 24, -10, 20, -18, 12, -28, 14];
  const top = topPattern[index % topPattern.length];
  const duration = 11.8 + index * 1.35 + scale * 4;
  const delay = -index * 1.8;
  const drift = driftPattern[index % driftPattern.length];
  const tilt = tiltPattern[index % tiltPattern.length];
  const spinDuration = 9.4 + (index % 4) * 1.25;

  return `
    <span
      class="chip-fleet__chip"
      style="--top:${top}%; --duration:${duration.toFixed(2)}s; --delay:${delay.toFixed(2)}s; --scale:${scale.toFixed(2)}; --drift:${drift.toFixed(2)}px;"
    >
      <span class="chip-fleet__chip-frame" style="--tilt:${tilt}deg; --spin-duration:${spinDuration.toFixed(2)}s;">
        <img class="chip-fleet__chip-image" src="//www.twisted-electrons.com/cdn/shop/t/11/assets/twisted-chip.png?v=98821924938248752171782115106" alt="" loading="lazy" decoding="async" width="227" height="193">
      </span>
    </span>
  `;
}

function renderChipFleet() {
  if (!chipFleet) {
    return;
  }

  const particleCount = window.matchMedia("(max-width: 900px)").matches ? 22 : 34;
  const particles = Array.from({ length: particleCount }, (_, index) => chipParticle(index)).join("");
  const scales = window.matchMedia("(max-width: 900px)").matches
    ? [0.28, 0.32, 0.36, 0.4, 0.48, 0.58, 0.72]
    : [0.24, 0.28, 0.3, 0.34, 0.38, 0.42, 0.46, 0.52, 0.6, 0.74];
  const chips = scales.map(chipSprite).join("");

  chipFleet.innerHTML = `${particles}${chips}`;
}

function productCard(product) {
  const specs = product.specs.map((spec) => `<li>${spec}</li>`).join("");

  return `
    <article class="product-card reveal" data-category="${product.category}">
      <a class="product-card__image-link" href="${product.shop}" aria-label="Shop ${product.name}">
        <img class="product-card__image" src="${product.image}" srcset="${product.imageSrcset}" sizes="(min-width: 1200px) 25vw, (min-width: 720px) 50vw, 100vw" alt="${product.alt}" loading="lazy" width="1000" height="750">
      </a>
      <div class="product-card__body">
        <div class="product-card__top">
          <div>
            <p class="eyebrow">${product.type}</p>
            <h3>${product.name}</h3>
          </div>
          <span class="product-card__price">${product.price}</span>
        </div>
        <p class="product-card__tagline">${product.tagline}</p>
        <ul class="product-card__specs">${specs}</ul>
        <div class="product-card__actions">
          <a class="product-card__action" href="${product.shop}">${product.id === "flexfm" ? "Preorder" : "Shop"}</a>
        </div>
      </div>
    </article>
  `;
}

function renderProducts() {
  if (!productGrid) {
    return;
  }

  // Keep acid8's product data for support links, but omit its storefront card.
  productGrid.innerHTML = products.filter(({ id }) => id !== "acid8").map(productCard).join("");
}

function supportRows(resource) {
  const manual = resource.links.find(({ tone }) => tone === "manual") || null;
  const firmware = resource.links.filter(({ tone }) => tone === "firmware");
  const controllers = resource.links.filter(({ tone }) => tone === "controller");
  const extras = resource.links.filter(({ tone }) => tone === "utility");
  const tools = resource.links.filter(({ tone }) => tone === "tool");

  return [
    { label: "Manual", links: manual ? [manual] : [] },
    { label: "Firmware", links: firmware },
    ...(controllers.length ? [{ label: "Controller", links: controllers }] : []),
    { label: "Extras", links: extras },
    { label: "Tool", links: tools }
  ];
}

function supportValue(links) {
  if (!links.length) {
    return '<span class="support-card__empty">-</span>';
  }

  return links.map(({ label, href, tone, tooltip }, index) => {
    const escapedTooltip = tooltip
      ? tooltip.replace(/&/g, "&amp;").replace(/"/g, "&quot;")
      : "";
    const tooltipAttrs = tooltip ? ` data-tooltip="${escapedTooltip}" title="${escapedTooltip}"` : "";
    const tooltipClass = tooltip ? " support-card__value--has-tooltip" : "";
    const displayAttr = href.includes("#firmware-update") ? ' style="display: inline-flex"' : "";
    const separator = index > 0 ? '<span class="support-card__separator" aria-hidden="true">|</span>' : "";

    return `${separator}
      <a class="support-card__value support-card__value--${tone}${tooltipClass}" href="${href}" target="_blank" rel="noreferrer noopener"${tooltipAttrs}${displayAttr}>${label}</a>
    `;
  }).join("");
}

function supportCard(resource) {
  const product = products.find(({ id }) => id === resource.id) || null;
  const productHref = product ? product.shop : "";
  const rows = supportRows(resource).map(({ label, links }) => `
    <li class="support-card__row">
      <span class="support-card__label">${label}</span>
      <span class="support-card__content">${supportValue(links)}</span>
    </li>
  `).join("");
  const media = `
    <img src="${resource.image}" alt="${resource.alt}" loading="lazy" width="121" height="121">
  `;
  const mediaHtml = productHref
    ? `<a class="support-card__media-link" href="${productHref}" aria-label="Open ${resource.name} product page">${media}</a>`
    : media;

  return `
    <article class="support-card reveal" data-support-card="${resource.id}">
      <div class="support-card__media">
        ${mediaHtml}
      </div>
      <div class="support-card__body">
        <h3>${resource.name}</h3>
        <ul class="support-card__rows">${rows}</ul>
      </div>
    </article>
  `;
}

function syncSupportManualGrid() {
  if (!supportGrid) {
    return;
  }

  const isMobile = window.matchMedia("(max-width: 560px)").matches;
  supportGrid.style.gridTemplateColumns = isMobile ? "1fr" : "";
  supportGrid.style.gap = isMobile ? "12px" : "";

  supportGrid.querySelectorAll(".support-card").forEach((card) => {
    card.style.display = "";
    card.style.gridTemplateColumns = isMobile ? "72px minmax(0, 1fr)" : "";
    card.style.alignItems = isMobile ? "flex-start" : "";
    card.style.justifyItems = isMobile ? "stretch" : "";
    card.style.gap = isMobile ? "12px" : "";
    card.style.minHeight = isMobile ? "0" : "";
    card.style.padding = isMobile ? "12px" : "";
    card.style.textAlign = isMobile ? "left" : "";

    const media = card.querySelector(".support-card__media");
    if (media) {
      media.style.width = isMobile ? "72px" : "";
      media.style.maxWidth = isMobile ? "72px" : "";
    }

    const body = card.querySelector(".support-card__body");
    if (body) {
      body.style.justifyItems = isMobile ? "stretch" : "";
      body.style.gap = isMobile ? "8px" : "";
    }

    const title = card.querySelector("h3");
    if (title) {
      title.style.fontSize = isMobile ? "15px" : "";
      title.style.textAlign = isMobile ? "left" : "";
    }

    const rows = card.querySelector(".support-card__rows");
    if (rows) {
      rows.style.display = isMobile ? "grid" : "";
      rows.style.gap = isMobile ? "6px" : "";
      rows.style.width = isMobile ? "100%" : "";
    }
  });
}

function renderSupportResources() {
  if (!supportGrid) {
    return;
  }

  supportGrid.innerHTML = supportResources.map(supportCard).join("");
  syncSupportManualGrid();
}

window.addEventListener("resize", syncSupportManualGrid);

function setHero(productId) {
  if (!heroImage || !heroTitle || !heroCopy || !heroShop || !heroStats) {
    return;
  }

  const product = products.find(({ id }) => id === productId) || products[0];
  const [first, second, third] = product.stats;
  activeHeroId = product.id;

  heroImage.src = product.image;
  heroImage.srcset = product.imageSrcset;
  heroImage.sizes = "100vw";
  heroImage.alt = product.alt;
  heroTitle.textContent = product.name;
  heroCopy.textContent = product.tagline;
  heroShop.href = product.shop;
  heroShop.textContent = product.cta || `Shop ${product.name}`;
  heroStats.innerHTML = [first, second, third].map(([label, value]) => `
    <div>
      <dt>${label}</dt>
      <dd>${value}</dd>
    </div>
  `).join("");

  heroButtons.forEach((button) => {
    const isActive = button.dataset.heroKey === productId;
    button.classList.toggle("is-active", isActive);
    button.setAttribute("aria-selected", String(isActive));
  });
}

function transitionHero(productId) {
  if (!productId || productId === activeHeroId) {
    return;
  }

  if (!heroSection || window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
    setHero(productId);
    return;
  }

  activeHeroId = productId;
  window.clearTimeout(heroTransitionTimer);
  heroSection.classList.add("is-transitioning");
  heroTransitionTimer = window.setTimeout(() => {
    setHero(productId);
    heroSection.classList.remove("is-transitioning");
  }, HERO_FADE_MS);
}

function stopHeroRotation() {
  if (heroRotationTimer === null) {
    return;
  }

  window.clearTimeout(heroRotationTimer);
  heroRotationTimer = null;
}

function startHeroRotation() {
  if (heroRotationManuallyStopped || !heroSection || heroRotationIds.length === 0 || heroRotationIds.length === 1 || window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
    return;
  }

  stopHeroRotation();
  const rotateHero = () => {
    if (document.hidden) {
      heroRotationTimer = null;
      return;
    }

    const currentIndex = heroRotationIds.indexOf(activeHeroId);
    const nextIndex = currentIndex === -1 ? 0 : (currentIndex + 1) % heroRotationIds.length;
    transitionHero(heroRotationIds[nextIndex]);
    heroRotationTimer = window.setTimeout(rotateHero, HERO_ROTATE_MS);
  };

  heroRotationTimer = window.setTimeout(rotateHero, HERO_ROTATE_MS);
}

function bindArchiveGalleries() {
  document.querySelectorAll("[data-archive-gallery]").forEach((gallery) => {
    const stage = gallery.querySelector("[data-archive-stage]");
    const thumbs = Array.from(gallery.querySelectorAll("[data-archive-thumb]"));

    if (!stage || !thumbs.length) {
      return;
    }

    thumbs.forEach((thumb) => {
      thumb.addEventListener("click", () => {
        stage.src = thumb.dataset.imageSrc || stage.src;
        stage.alt = thumb.dataset.imageAlt || stage.alt;

        thumbs.forEach((item) => {
          item.classList.remove("is-active");
          item.setAttribute("aria-pressed", "false");
        });

        thumb.classList.add("is-active");
        thumb.setAttribute("aria-pressed", "true");
      });
    });
  });
}

function bindMediaGates() {
  document.querySelectorAll("[data-media-gate]").forEach((gate) => {
    const loadButton = gate.querySelector("[data-media-load]");
    const source = gate.dataset.mediaSrc;
    const title = gate.dataset.mediaTitle || "Embedded media";
    const kind = gate.dataset.mediaKind || "";

    if (!loadButton || !source) {
      return;
    }

    loadButton.addEventListener("click", () => {
      const isVideoFile = kind === "video" || /\.(mp4|webm|ogg)(?:$|\?)/i.test(source);
      const frame = document.createElement(isVideoFile ? "video" : "iframe");

      frame.className = isVideoFile ? "product-demo-frame product-demo-video" : "product-demo-frame";
      frame.src = source;

      if (isVideoFile) {
        frame.controls = true;
        frame.preload = "metadata";
        frame.playsInline = true;
        frame.setAttribute("aria-label", title);
      } else {
        frame.title = title;
        frame.loading = "lazy";
        frame.allow = "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share";
        frame.allowFullscreen = true;
      }

      gate.classList.remove("product-detail-panel__frame--consent");
      gate.replaceChildren(frame);
    }, { once: true });
  });
}

function patchAy3InlinePanel() {
  if (window.location.pathname.replace(/\/$/, "") !== "/products/ay3-mkii") {
    return;
  }

  document.querySelectorAll(".product-gallery__archive").forEach((gallery) => {
    if (gallery.querySelector("img[src*='twistedelectrons_ay3desktop']")) {
      gallery.remove();
    }
  });

  const productSummary = document.querySelector(".product-summary");
  if (productSummary) {
    productSummary.classList.remove("product-summary--with-inline-media");
    productSummary.querySelectorAll(".product-summary__inline-media").forEach((figure) => figure.remove());
    productSummary.querySelectorAll("img").forEach((image) => {
      const source = image.currentSrc || image.src || "";
      const alt = image.alt || "";
      if (
        source.includes("ay3-inline-panel") ||
        source.includes("twistedelectrons_ay3desktop") ||
        alt.includes("AY3 MKII front panel controls")
      ) {
        const wrapper = image.closest("figure, p");
        if (wrapper && wrapper.childElementCount === 1 && wrapper.textContent.trim() === "") {
          wrapper.remove();
        } else {
          image.remove();
        }
      }
    });
  }

  const summary = document.querySelector(".product-summary .rte");
  if (!summary) {
    return;
  }

  const style = document.createElement("style");
  style.textContent = `
    .ay3-inline-panel {
      float: right;
      width: min(42%, 360px);
      margin: 0 0 18px 24px;
    }
    .ay3-inline-panel img {
      width: 100%;
      height: auto;
      border: 0;
      border-radius: 0;
      background: transparent;
      display: block;
    }
    @media (max-width: 760px) {
      .ay3-inline-panel {
        float: none;
        width: min(100%, 420px);
        margin: 0 0 18px;
      }
    }
  `;
  document.head.append(style);

  const figure = document.createElement("figure");
  figure.className = "ay3-inline-panel";
  figure.innerHTML = `
    <img
      src="//www.twisted-electrons.com/cdn/shop/t/11/assets/ay3-inline-panel.png?v=121431799357994377271782115106"
      alt="AY3 MKII front panel controls"
      loading="lazy"
      width="680"
      height="493"
    >
  `;

  const firstParagraph = summary.querySelector("p");
  if (firstParagraph) {
    firstParagraph.before(figure);
  } else {
    summary.prepend(figure);
  }
}

function patchNativeAudioDemos() {
  const productAudio = {
    "/products/twistfm": [
      ["Phoenix Springs Leo's Theme", "//www.twisted-electrons.com/cdn/shop/t/11/assets/audio-twistfm-1934212862.m4a?v=132058688812845195621782115107", "audio/mp4"]
    ],
    "/products/blastbeats": [
      ["BlastBeats Demo sounds", "//www.twisted-electrons.com/cdn/shop/t/11/assets/audio-blastbeats-1176467680.m4a?v=148499644569510318341782115107", "audio/mp4"]
    ],
    "/products/megafm": [
      ["MEGAfm sounds", "//www.twisted-electrons.com/cdn/shop/t/11/assets/audio-megafm-01-739614757.m4a?v=63755435615127894001782115107", "audio/mp4"],
      ["Relax", "//www.twisted-electrons.com/cdn/shop/t/11/assets/audio-megafm-02-741193753.m4a?v=150038233579455902591782115106", "audio/mp4"],
      ["Theta - dusty ice crystal", "//www.twisted-electrons.com/cdn/shop/t/11/assets/audio-megafm-03-815311114.m4a?v=53297134060895069001782115107", "audio/mp4"],
      ["artist K21 pushing MegaFM Hard", "//www.twisted-electrons.com/cdn/shop/t/11/assets/audio-megafm-04-809499082.m4a?v=92734124099862277471782115106", "audio/mp4"],
      ["Artist Yung Elderz - Triphop", "//www.twisted-electrons.com/cdn/shop/t/11/assets/audio-megafm-05-809500735.m4a?v=22187497321845825241782115107", "audio/mp4"],
      ["Sam's Barber", "//www.twisted-electrons.com/cdn/shop/t/11/assets/audio-megafm-06-741193696.m4a?v=79871224020663678431782115106", "audio/mp4"],
      ["fmAcid?", "//www.twisted-electrons.com/cdn/shop/t/11/assets/audio-megafm-07-741193837.m4a?v=22939907793949197141782115106", "audio/mp4"],
      ["Bounce", "//www.twisted-electrons.com/cdn/shop/t/11/assets/audio-megafm-08-741193816.m4a?v=169751777021857868671782115106", "audio/mp4"],
      ["Virus Outside", "//www.twisted-electrons.com/cdn/shop/t/11/assets/audio-megafm-09-823516930.m4a?v=86038837973536580081782115106", "audio/mp4"]
    ],
    "/products/therapsid-mk3": [
      ["TherapSid (6581 SID)", "//www.twisted-electrons.com/cdn/shop/t/11/assets/audio-therapsid-167677106.mp3?v=52954773386322438881782115109", "audio/mpeg"]
    ],
    "/products/ay3-mkii": [
      ["LEAD1", "//www.twisted-electrons.com/cdn/shop/t/11/assets/audio-ay3-01-248026301.mp3?v=120490901897944596621782115107", "audio/mpeg"],
      ["BASS1", "//www.twisted-electrons.com/cdn/shop/t/11/assets/audio-ay3-02-248026286.m4a?v=135106334795973867941782115106", "audio/mp4"],
      ["BEAT1", "//www.twisted-electrons.com/cdn/shop/t/11/assets/audio-ay3-03-248026297.mp3?v=179007614890456525741782115106", "audio/mpeg"],
      ["BEAT2", "//www.twisted-electrons.com/cdn/shop/t/11/assets/audio-ay3-04-248026293.m4a?v=40847679746812687081782115106", "audio/mp4"],
      ["ARPS", "//www.twisted-electrons.com/cdn/shop/t/11/assets/audio-ay3-05-248026284.m4a?v=141278046121079100771782115106", "audio/mp4"],
      ["ARPS2", "//www.twisted-electrons.com/cdn/shop/t/11/assets/audio-ay3-06-248026292.mp3?v=130077276727202857721782115106", "audio/mpeg"],
      ["GATE FX", "//www.twisted-electrons.com/cdn/shop/t/11/assets/audio-ay3-07-248026290.mp3?v=170138172547018724751782115106", "audio/mpeg"]
    ],
    "/products/hapines-l": [
      ["hapiNes demo1", "//www.twisted-electrons.com/cdn/shop/t/11/assets/audio-hapines-01-491743215.m4a?v=56355946217022176301782115106", "audio/mp4"],
      ["hapiNES + Moog", "//www.twisted-electrons.com/cdn/shop/t/11/assets/audio-hapines-02-492751218.m4a?v=9447752593061010641782115106", "audio/mp4"],
      ["HapiNES TMHT underwater", "//www.twisted-electrons.com/cdn/shop/t/11/assets/audio-hapines-03-491832771.m4a?v=144138601444490591421782115106", "audio/mp4"],
      ["hapiNES robo", "//www.twisted-electrons.com/cdn/shop/t/11/assets/audio-hapines-04-491905596.m4a?v=22985656466371949111782115106", "audio/mp4"]
    ],
    "/products/acid8-mkii": [
      ["Acid8 Test 1", "//www.twisted-electrons.com/cdn/shop/t/11/assets/audio-acid8-202916848.mp3?v=81002308084522724011782115107", "audio/mpeg"]
    ]
  };

  const path = window.location.pathname.replace(/\/$/, "");
  const tracks = productAudio[path];
  if (!tracks || document.querySelector(".product-audio-grid")) {
    return;
  }

  const soundcloudGate = document.querySelector("[data-media-src*='soundcloud.com']");
  if (!soundcloudGate) {
    return;
  }

  const grid = document.createElement("div");
  grid.className = "product-audio-grid";
  grid.setAttribute("aria-label", "Audio demos");
  grid.innerHTML = tracks.map(([title, source, type]) => `
    <figure class="product-audio-card">
      <figcaption class="product-audio-card__title">${title}</figcaption>
      <div class="product-audio-meter" aria-hidden="true" data-audio-meter>
        <span class="product-audio-meter__bar"></span>
      </div>
      <audio class="product-audio-card__player" controls preload="metadata">
        <source src="${source}" type="${type}">
      </audio>
    </figure>
  `).join("");

  soundcloudGate.replaceWith(grid);
}

function bindCustomAudioPlayers() {
  const audioPlayers = Array.from(document.querySelectorAll(".product-audio-card__player"));
  if (!audioPlayers.length) {
    return;
  }

  const formatTime = (seconds) => {
    if (!Number.isFinite(seconds)) {
      return "0:00";
    }

    const rounded = Math.max(0, Math.floor(seconds));
    const minutes = Math.floor(rounded / 60);
    const remainder = String(rounded % 60).padStart(2, "0");
    return `${minutes}:${remainder}`;
  };

  audioPlayers.forEach((audio) => {
    if (audio.dataset.customPlayerReady === "true") {
      return;
    }

    audio.controls = false;
    audio.dataset.customPlayerReady = "true";

    const controls = document.createElement("div");
    controls.className = "product-audio-controls";
    controls.innerHTML = `
      <button class="product-audio-controls__button" type="button" aria-label="Play audio"></button>
      <input class="product-audio-controls__progress" type="range" min="0" max="1000" value="0" step="1" aria-label="Audio progress">
      <span class="product-audio-controls__time">0:00</span>
    `;
    audio.insertAdjacentElement("afterend", controls);

    const playButton = controls.querySelector(".product-audio-controls__button");
    const progress = controls.querySelector(".product-audio-controls__progress");
    const time = controls.querySelector(".product-audio-controls__time");

    const updateProgress = () => {
      const duration = audio.duration || 0;
      const percent = duration ? (audio.currentTime / duration) : 0;
      progress.value = String(Math.round(percent * 1000));
      progress.style.setProperty("--audio-progress", `${Math.min(100, Math.max(0, percent * 100))}%`);
      time.textContent = `${formatTime(audio.currentTime)} / ${formatTime(duration)}`;
    };

    playButton.addEventListener("click", () => {
      if (audio.paused) {
        audio.play();
        return;
      }

      audio.pause();
    });

    progress.addEventListener("input", () => {
      if (!audio.duration) {
        return;
      }

      audio.currentTime = (Number(progress.value) / 1000) * audio.duration;
      updateProgress();
    });

    audio.addEventListener("loadedmetadata", updateProgress);
    audio.addEventListener("timeupdate", updateProgress);
    audio.addEventListener("play", () => {
      playButton.classList.add("is-playing");
      playButton.setAttribute("aria-label", "Pause audio");
    });
    audio.addEventListener("pause", () => {
      playButton.classList.remove("is-playing");
      playButton.setAttribute("aria-label", "Play audio");
      updateProgress();
    });
    audio.addEventListener("ended", () => {
      playButton.classList.remove("is-playing");
      playButton.setAttribute("aria-label", "Play audio");
      updateProgress();
    });

    updateProgress();
  });
}

function bindAudioMeters() {
  const audioPlayers = Array.from(document.querySelectorAll(".product-audio-card__player"));
  if (!audioPlayers.length) {
    return;
  }

  const AudioContextClass = window.AudioContext || window.webkitAudioContext;
  if (!AudioContextClass) {
    return;
  }

  let audioContext = null;
  const meterState = new WeakMap();
  const segmentCount = 24;

  const idleMeter = (bar) => {
    Array.from(bar.children).forEach((segment, index) => {
      const phase = index / Math.max(1, segmentCount - 1);
      const level = 0.08 + Math.sin(phase * Math.PI) * 0.08;
      segment.style.setProperty("--spectrum-level", level.toFixed(3));
      segment.style.opacity = "0.42";
    });
  };

  const ensureSpectrumSegments = (bar) => {
    if (bar.children.length === segmentCount) {
      return Array.from(bar.children);
    }

    bar.replaceChildren(...Array.from({ length: segmentCount }, () => {
      const segment = document.createElement("span");
      segment.className = "product-audio-meter__segment";
      return segment;
    }));
    return Array.from(bar.children);
  };

  const setupMeter = (audio) => {
    if (meterState.has(audio)) {
      return meterState.get(audio);
    }

    const card = audio.closest(".product-audio-card");
    const bar = card ? card.querySelector(".product-audio-meter__bar") : null;
    if (!bar) {
      return null;
    }

    const segments = ensureSpectrumSegments(bar);
    audioContext = audioContext || new AudioContextClass();
    const analyser = audioContext.createAnalyser();
    analyser.fftSize = 256;
    analyser.smoothingTimeConstant = 0.82;

    const source = audio.dataset.vuSourceReady === "true"
      ? null
      : audioContext.createMediaElementSource(audio);
    if (source) {
      source.connect(analyser);
      analyser.connect(audioContext.destination);
      audio.dataset.vuSourceReady = "true";
    }

    const data = new Uint8Array(analyser.frequencyBinCount);
    const state = { analyser, bar, segments, data, frame: 0 };
    meterState.set(audio, state);
    idleMeter(bar);
    return state;
  };

  const animateMeter = (audio) => {
    const state = setupMeter(audio);
    if (!state) {
      return;
    }

    if (audio.paused || audio.ended) {
      idleMeter(state.bar);
      state.frame = 0;
      return;
    }

    state.analyser.getByteFrequencyData(state.data);
    const usableBins = Math.floor(state.data.length * 0.76);
    state.segments.forEach((segment, index) => {
      const start = Math.floor((index / segmentCount) * usableBins);
      const end = Math.max(start + 1, Math.floor(((index + 1) / segmentCount) * usableBins));
      let total = 0;
      let peak = 0;
      for (let dataIndex = start; dataIndex !== end; dataIndex += 1) {
        const value = state.data[dataIndex] || 0;
        total += value;
        peak = Math.max(peak, value);
      }
      const average = total / Math.max(1, end - start) / 255;
      const weighted = average * 0.72 + (peak / 255) * 0.38;
      const level = Math.min(1, Math.max(0.06, weighted * (1.48 - index * 0.012)));
      segment.style.setProperty("--spectrum-level", level.toFixed(3));
      segment.style.opacity = String(Math.min(1, 0.45 + level * 0.75));
    });
    state.frame = window.requestAnimationFrame(() => animateMeter(audio));
  };

  audioPlayers.forEach((audio) => {
    const card = audio.closest(".product-audio-card");
    const bar = card ? card.querySelector(".product-audio-meter__bar") : null;
    if (bar) {
      ensureSpectrumSegments(bar);
      idleMeter(bar);
    }

    audio.addEventListener("play", () => {
      const state = setupMeter(audio);
      if (!state) {
        return;
      }

      if (audioContext.state === "suspended") {
        audioContext.resume();
      }

      window.cancelAnimationFrame(state.frame);
      animateMeter(audio);
    });

    audio.addEventListener("pause", () => {
      const state = meterState.get(audio);
      if (state) {
        window.cancelAnimationFrame(state.frame);
        idleMeter(state.bar);
      }
    });

    audio.addEventListener("ended", () => {
      const state = meterState.get(audio);
      if (state) {
        window.cancelAnimationFrame(state.frame);
        idleMeter(state.bar);
      }
    });
  });
}

function observeReveal() {
  const elements = document.querySelectorAll(".reveal");

  if (!("IntersectionObserver" in window)) {
    elements.forEach((element) => element.classList.add("is-visible"));
    return;
  }

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        entry.target.classList.add("is-visible");
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.12 });

  elements.forEach((element) => observer.observe(element));
}

function ensureMobileNavAlignment() {
  if (document.getElementById("mobile-nav-alignment-fix")) {
    return;
  }

  const style = document.createElement("style");
  style.id = "mobile-nav-alignment-fix";
  style.textContent = `
@media (max-width: 900px) {
  .mobile-nav {
    right: auto !important;
    left: 50% !important;
    width: min(calc(100% - 24px), 420px) !important;
    grid-template-columns: repeat(3, minmax(0, 1fr)) !important;
    align-items: center !important;
    justify-content: center !important;
    transform: translateX(-50%) !important;
  }
}

@media (max-width: 560px) {
  .mobile-nav {
    width: min(calc(100% - 20px), 380px) !important;
  }
}`;
  document.head.appendChild(style);
}

function syncAboutCopy() {
  const aboutCopy = document.querySelector("#about .about-band__copy");
  if (!aboutCopy) {
    return;
  }

  const textParagraphs = Array.from(aboutCopy.querySelectorAll("p")).filter((paragraph) => (
    !paragraph.classList.contains("eyebrow") &&
    !paragraph.classList.contains("about-band__thanks-link")
  ));

  if (textParagraphs.length === 0) {
    return;
  }

  textParagraphs[0].textContent = "Twisted Electrons is driven by my love of the distinct sound chips found in vintage computers, video games and pinballs, and by the challenge of building modern synthesizers around that character.";

  if (textParagraphs[1]) {
    const linkOpen = String.fromCharCode(60) + "a href=\"https://calligramstudio.bandcamp.com/album/phoenix-springs-ost\" target=\"_blank\" rel=\"noreferrer noopener\">";
    const linkClose = String.fromCharCode(60) + "/a>";
    textParagraphs[1].innerHTML = "When I'm not designing and assembling Twisted Electrons instruments, I compose music for " + linkOpen + "video games" + linkClose + " and commercial projects.";
  }

  for (const paragraph of textParagraphs.slice(2)) {
    paragraph.remove();
  }
}

function bindInteractions() {
  heroButtons.forEach((button) => {
    button.addEventListener("click", () => {
      heroRotationManuallyStopped = true;
      stopHeroRotation();
      transitionHero(button.dataset.heroKey);
    });
  });

  if (heroSection && heroRotationIds.length > 1) {
    document.addEventListener("visibilitychange", () => {
      if (document.hidden) {
        stopHeroRotation();
        return;
      }

      if (!heroRotationManuallyStopped) {
        startHeroRotation();
      }
    });

    startHeroRotation();
  }

  bindArchiveGalleries();
  patchNativeAudioDemos();
  bindCustomAudioPlayers();
  bindAudioMeters();
  bindMediaGates();

  const header = document.querySelector("[data-header]");
  if (!header) {
    return;
  }

  const syncHeader = () => header.classList.toggle("is-scrolled", window.scrollY > 12);

  syncHeader();
  window.addEventListener("scroll", syncHeader, { passive: true });
}

function patchMegafmEditorLinks() {
  const newEditorHref = "//www.twisted-electrons.com/cdn/shop/t/11/assets/tool-megafm-editor.html?v=46735983435303560191782115107";

  document.querySelectorAll('a[href*="tool-megafm-index.html"]').forEach((link) => {
    link.href = newEditorHref;
  });

  document.querySelectorAll('[data-tool-src*="tool-megafm-index.html"]').forEach((frame) => {
    frame.dataset.toolSrc = newEditorHref;
    frame.setAttribute("data-tool-src", newEditorHref);
  });

  document.querySelectorAll(".product-resource-list").forEach((list) => {
    const macController = list.querySelector('a[href*="MEGAfm_Control_macOS"]');
    const winController = list.querySelector('a[href*="MEGAfm_Control_Windows"]');

    if (macController && winController && !list.querySelector(".product-resource-group--controller")) {
      const group = document.createElement("span");
      const label = document.createElement("span");
      const separator = document.createElement("span");

      group.className = "product-resource-group product-resource-group--controller";
      group.setAttribute("aria-label", "MEGAfm controller downloads");
      label.className = "product-resource-group__label";
      label.textContent = "CONTROLLER";
      separator.className = "product-resource-group__separator";
      separator.setAttribute("aria-hidden", "true");
      separator.textContent = "|";
      macController.textContent = "OSX";
      winController.textContent = "WIN";
      macController.classList.add("product-resource--controller");
      winController.classList.add("product-resource--controller");

      list.insertBefore(group, macController);
      group.append(label, macController, separator, winController);
    }

    const seen = new Set();

    list.querySelectorAll("a.product-resource").forEach((link) => {
      if (link.getAttribute("href")?.includes("tool-megafm-editor")) {
        link.textContent = "settings tool";
      }

      const key = `${link.textContent.trim()}::${link.getAttribute("href") || ""}`;

      if (seen.has(key)) {
        link.remove();
        return;
      }

      seen.add(key);
    });
  });
}

function patchMegafmProductSummary() {
  if (!document.querySelector(".product-template--megafm")) return;

  const summary = document.querySelector(".product-summary .rte");
  if (!summary || summary.textContent.includes("Firmware 5.0 opens the machine up")) return;

  summary.innerHTML = `
    <p>MEGAfm II is FM at its most physical: dual vintage chips, 12 voices, 32 operator sliders, and enough grit to move from glassy plucks to speaker-rattling bass. Firmware 5.0 adds full bidirectional SYSEX support, so editors and controllers can request data from the synth, display the current patch, and push complete changes back in real time.</p>
    <h3>Firmware 5.0 opens the machine up</h3>
    <p>The editor/VST adds full DAW integration while keeping MEGAfm as the instrument. Standalone macOS and Windows controller builds are also available from support. Thanks to <a href="https://github.com/sebastianmika" target="_blank" rel="noreferrer noopener">Sebastian</a> for the contribution.</p>
    <h3>Highlights</h3>
    <ul>
      <li>Firmware 5.0 with full bidirectional SYSEX support</li>
      <li>Editor workflows for operators, LFOs, arpeggiation, sequencing, links, and configuration</li>
      <li>Twelve-voice FM synthesizer built around dual vintage chips</li>
      <li>32 operator sliders for unusually direct access to the FM engine</li>
      <li>600 presets with easy bank transfer over SysEx</li>
    </ul>
  `;
}

function patchMegafmSysexFeatureCopy() {
  if (!document.querySelector(".product-template--megafm")) return;

  const heading = document.getElementById("megafm-editor-heading");
  const feature = heading ? heading.closest(".product-editor-feature") : null;
  const copy = feature ? feature.querySelector(".product-editor-feature__copy") : null;
  if (!copy) return;

  const paragraph = Array.from(copy.querySelectorAll("p")).find((node) => !node.classList.contains("eyebrow"));
  if (paragraph) {
    paragraph.textContent = "Firmware 5.0 lets MEGAfm talk back. The editor can request dumps from the hardware, make the patch visible, and push complete changes back in real time.";
  }

  copy.querySelector("ul")?.remove();
  copy.querySelector(".product-editor-feature__button")?.remove();
}

function patchMegafmEditorFeatureCopy() {
  if (!document.querySelector(".product-template--megafm")) return;

  const heading = document.getElementById("megafm-controller-heading");
  const feature = heading ? heading.closest(".product-editor-feature") : document.querySelector(".product-editor-feature--megafm.product-editor-feature--reverse");
  const copy = feature ? feature.querySelector(".product-editor-feature__copy") : null;
  if (!heading || !copy) return;

  heading.textContent = "DAW integration when you want it.";

  const paragraph = Array.from(copy.querySelectorAll("p")).find((node) => !node.classList.contains("eyebrow"));
  if (paragraph) {
    paragraph.innerHTML = 'The editor/VST brings MEGAfm into a DAW workflow for patch work and automation while keeping the hardware as the instrument. Standalone macOS and Windows controller builds are also available. Thanks to <a href="https://github.com/sebastianmika" target="_blank" rel="noreferrer noopener">Sebastian</a> for the contribution.';
  }

  copy.querySelector("ul")?.remove();
}

renderProducts();
renderSupportResources();
renderChipFleet();
patchAy3InlinePanel();
ensureMobileNavAlignment();
syncAboutCopy();
patchMegafmEditorLinks();
patchMegafmProductSummary();
patchMegafmSysexFeatureCopy();
patchMegafmEditorFeatureCopy();
setHero(activeHeroId);
bindInteractions();
observeReveal();

(() => {
  const repairLegacyProductsBanner = () => {
    if (!/\/pages\/legacy-products\/?$/.test(window.location.pathname)) return;

    const legacyBannerUrl = "//www.twisted-electrons.com/cdn/shop/t/11/assets/legacy.png?v=149003074419880071631782115106";

    document.querySelectorAll(".legacy-products-banner img").forEach((image) => {
      image.src = legacyBannerUrl;
      image.style.display = "block";
      image.style.width = "100%";
      image.style.height = "auto";
      image.style.minHeight = "240px";
      image.style.maxHeight = "420px";
      image.style.objectFit = "cover";
      image.style.filter = "brightness(1.35) contrast(1.08)";
    });
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", repairLegacyProductsBanner, { once: true });
  } else {
    repairLegacyProductsBanner();
  }

  window.addEventListener("load", repairLegacyProductsBanner, { once: true });
  window.setTimeout(repairLegacyProductsBanner, 300);
})();
